import React from 'react';
import { UploadedFile } from '../../types';
import Uploader from '../uploader/Uploader';
import ImageWithProgress from '../uploader/ImageWithProgress';
import { isDevelopment } from '../../constants/app';
import { useImageWidgetMutations } from '../../mutations/widgets/image';
import { retrieveBrandsApi, saveMediaApi } from '../../helpers/api/uploadApi';

interface Props {
  widgetId: string;
  columnIndex: number;
  sectionId: string;
  file: UploadedFile;
}

const PersonalFileWidget = ({
  sectionId,
  widgetId,
  file,
  columnIndex,
}: Props) => {
  const [imageObj, setImageObj] = React.useState<File>(null);
  const { uploadImageWidget } = useImageWidgetMutations(
    sectionId,
    columnIndex,
    widgetId,
  );

  React.useEffect(() => {
    async function getFileFromBlob(fileUrl: string) {
      await fetch(fileUrl)
        .then(r => r.blob())
        .then(blobFile =>
          setImageObj(
            new File([blobFile], file.filename, { type: 'image/png' }),
          ),
        )
        .catch(e => {
          throw new Error(e);
        });
    }

    getFileFromBlob(file.fileBlob);
  }, [file?.fileBlob, file?.filename]);

  const onUploadCompleted = async (fileId: string) => {
    const brands = await retrieveBrandsApi();
    const brandId = brands[0].id;

    const { data: saveMedia } = await saveMediaApi(fileId, brandId, file);
    uploadImageWidget.mutate({
      assetId: saveMedia.mediaid,
      columnIndex,
      widgetId,
      sectionId,
    });
  };

  return (
    <Uploader
      onFileUploadCompleted={onUploadCompleted}
      intent="upload_main_uploader_asset"
      isPublic={isDevelopment}
      files={imageObj ? [imageObj] : []}
    >
      {({ fileUploads }) => {
        const progress = (fileUploads[0] && fileUploads[0].progress) || 0;

        return (
          <ImageWithProgress src={file.fileBlob} uploadProgress={progress} />
        );
      }}
    </Uploader>
  );
};

export default PersonalFileWidget;
